import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, Home as HomeIcon } from "lucide-react";
import {
  Sheet, SheetContent, SheetTitle, SheetTrigger,
} from "@/components/ui/sheet";
import SidebarContent from "@/components/SidebarContent";

export default function MobileNav() {
  const [open, setOpen] = useState(false);

  return (
    <div className="md:hidden sticky top-0 z-30 flex items-center justify-between h-14 px-4 border-b border-[var(--app-line)] bg-white/85 backdrop-blur">
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <button
            aria-label="Open menu"
            data-testid="mobile-menu-button"
            className="p-2 -ml-2 rounded-full hover:bg-[var(--app-surface)] transition-colors"
          >
            <Menu size={22} />
          </button>
        </SheetTrigger>
        <SheetContent
          side="left"
          className="p-0 w-72 max-w-[85vw]"
          data-testid="mobile-drawer"
        >
          <SheetTitle className="sr-only">Navigation</SheetTitle>
          <SidebarContent onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>

      <Link
        to="/dashboard"
        className="flex items-center gap-2"
        data-testid="mobile-brand"
      >
        <span className="inline-grid place-items-center w-8 h-8 rounded-full bg-[var(--app-black)] text-white">
          <HomeIcon size={15} strokeWidth={2.4} />
        </span>
        <div className="font-display text-base leading-none">FlipPilot</div>
      </Link>

      <div className="w-9" />
    </div>
  );
}
